import * as queryString from "query-string";
import locales from "../config/i18n";
import { CmsAPI } from "./AxiosInstances";
import parse from "html-react-parser";

/**
 * @property countriesConnection
 * @property country_name
 * @property country_name__global
 * @property country_name__zh
 * @property country_name__ja
 * @property country_name__kr
 * @property country_name__es
 */

export const getAllCountryNamesForChina = () => {
  return CmsAPI.get(
    `/graphql?query=query {
      countries ( pagination: { limit: 100 } sort:"sortid",  locale: "zh" ) {
        data {
          attributes {
            country_name
            country_code
            country_description
            sortid
            localizations {
              data {
                attributes {
                  country_name
                  country_code
                  country_description
                  sortid
                  locale
                }
              }
            }
          }
        }
      }
        }`
  ).then((response) =>
    response.data.data.countries.data.map((country) => ({
      label: country.attributes.country_name,
      value: {
        global: country.attributes.country_name,
      },
      // sortid: country.attributes.sortid,
    }))
  );
};

export const getAllCountryNames = () => {
  return CmsAPI.get(
    `/graphql?query=query {
      countries ( pagination: { limit: 100 } sort:"sortid" ) {
        data {
          attributes {
            country_name
            country_code
            country_description
            sortid
            localizations {
              data {
                attributes {
                  country_name
                  country_code
                  country_description
                  sortid
                  locale
                }
              }
            }
          }
        }
      }
        }`
  ).then((response) =>
    response.data.data.countries.data.map((country) => ({
      label: country.attributes.country_name,
      value: {
        global: country.attributes.country_name,
      },
      // sortid: country.attributes.sortid,
    }))
  );
};

export const getLastElement = (arr) =>
  arr && arr.length ? arr[arr.length - 1] : null;

export const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const getPathFromName = (name) =>
  name
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

export const addToQueryParams = (newParams) => {
  if (typeof window === "undefined") return;
  let currentParams = queryString.parse(window.location.search);
  return { ...currentParams, ...newParams };
};

export const removeQueryParams = (paramToRemove) => {
  if (typeof window === "undefined") return;
  let params = queryString.parse(window.location.search);
  delete params[paramToRemove];
  return params;
};

export const getLocalStorageItem = (item) =>
  JSON.parse(localStorage.getItem(item));

export const getLocalStorageCustomer = () => getLocalStorageItem("customer");

export const getLocalizedPath = (lang, alias, path) => {
  return typeof locales[lang].default !== "undefined" && locales[lang].default
    ? `${path}`
    : `/${typeof alias !== "undefined" ? alias : locales[lang].path}${path}`;
};

export const getLeaderData = (
  globalData,
  PageContent,
  field,
  locale,
  filter
) => {
  let allLocaleData = PageContent;

  var localizedData;

  if (
    allLocaleData.data.find((item) => item.attributes.locale === locale) !==
    undefined
  ) {
    localizedData = allLocaleData.data.find(
      (item) => item.attributes.locale === locale
    );
  } else {
    localizedData = globalData;
  }

  return localizedData;
};

export const getParsedData = (item) => {
  if (typeof item !== "string") {
    return parse("");
  } else {
    return parse(`${item}`);
  }
};

export const getContentData = (PageContent, field, locale, filter) => {
  let allLocaleData = PageContent().allStrapiPage.nodes;

  var localizedData;

  if (
    allLocaleData.filter(
      (x) => x["locale"] === (locale === "global" ? "en" : locale)
    ).length > 0
  ) {
    localizedData = allLocaleData.filter(
      (x) => x["locale"] === (locale === "global" ? "en" : locale)
    )[0][`${field}`];
  } else {
    localizedData = allLocaleData.filter((x) => x["locale"] === "en")[0][
      `${field}`
    ];
  }

  var globalData = allLocaleData.filter((x) => x["locale"] === "en")[0][
    `${field}`
  ];

  function convertToArray(obj) {
    if (obj instanceof Array) {
      return obj;
    } else {
      return [obj];
    }
  }

  if (filter) {
    let filteredLocalizedData = () => {
      if (localizedData) {
        if (
          convertToArray(localizedData).filter(
            (field) => field.name_ === filter
          ).length > 0
        ) {
          let localFilterImage = convertToArray(localizedData).filter(
            (field) => field.name_ === filter
          );

          if (localFilterImage[0].image === (undefined || null)) {
            localFilterImage[0].image = globalData.filter(
              (field) => field.name_ === filter
            )[0].image;
          }
          return localFilterImage;
        } else {
          return convertToArray(globalData).filter(
            (field) => field.name_ === filter
          );
        }
      } else {
        return convertToArray(globalData).filter(
          (field) => field.name_ === filter
        );
      }
    };
    return filteredLocalizedData()[0];
  }

  // localFilterImage.map((x, i) => {
  //   if (x.image === undefined || x.image === null) {
  //     x.image = globalData[i]?.image;
  //   }
  //   if (x.image_mobile === undefined || x.image_mobile === null) {
  //     x.image_mobile = globalData[i]?.image_mobile;
  //   }
  // });

  let data = () => {
    if (
      localizedData &&
      convertToArray(localizedData).length > 0 &&
      localizedData !== null
    ) {
      return localizedData;
    } else {
      return globalData;
    }
  };

  return data();
};

export const getContentOnePageData = (PageContent, field, locale, filter) => {
  let localizedData = PageContent().data[`${field}`];
  let globalData = PageContent().data[`${field}`];

  if (filter) {
    let filteredLocalizedData = () => {
      if (localizedData) {
        if (
          localizedData.filter((field) => field.name_ === filter).length > 0
        ) {
          let localFilterImage = localizedData.filter(
            (field) => field.name_ === filter
          );
          if (localFilterImage[0].image === (undefined || null)) {
            localFilterImage[0].image = globalData.filter(
              (field) => field.name_ === filter
            )[0].image;
          }

          return localFilterImage;
        } else {
          console.error(
            `Warning: Name_ ${filter} in ${field}__${locale} not found, showing data from ${field}__global instead`
          );
          return globalData.filter((field) => field.name_ === filter);
        }
      } else {
        console.error(
          `Warning: ${field}__${locale} not found, showing data from ${field}__global instead`
        );
        return globalData.filter((field) => field.name_ === filter);
      }
    };
    return filteredLocalizedData()[0];
  }

  let data = () => {
    if (localizedData) {
      return localizedData;
    } else {
      console.error(
        `Warning: ${field}__${locale} not found, showing data from ${field}__global instead`
      );
      return globalData;
    }
  };

  return data();
};

export const getStaticData = (data, locale) => {
  return data[locale] ? data[locale] : data["global"];
};

export const getSSRData = (globalData, data, field, locale) => {
  let localizedFieldName = `${field}`;
  let globalFieldName = `${field}`;

  return data?.attributes && data?.attributes[localizedFieldName]
    ? data?.attributes[localizedFieldName]
    : globalData?.attributes[globalFieldName];
};

export const getSSRLocalData = (data, field, locale) => {
  let localizedFieldName = `${field}`;
  let globalFieldName = `${field}`;
  return data[localizedFieldName]
    ? data[localizedFieldName]
    : data[globalFieldName];
};

export const scrollToRef = (ref, offsetTop) => {
  typeof window !== "undefined" &&
    window.scrollTo(0, ref.current.offsetTop - (offsetTop ? offsetTop : 176));
};

const urlParseRE =
  /^(((([^:\/#\?]+:)?(?:(\/\/)((?:(([^:@\/#\?]+)(?:\:([^:@\/#\?]+))?)@)?(([^:\/#\?\]\[]+|\[[^\/\]@#?]+\])(?:\:([0-9]+))?))?)?)?((\/?(?:[^\/\?#]+\/+)*)([^\?#]*)))?(\?[^#]+)?)(#.*)?/;

export const urlParser = (url) => {
  return urlParseRE.exec(url);
};

export const isUrl = (string) => {
  return string.startsWith("http");
};

/**
 * isTLD
 * Checks if the current TLD is equal to the input param
 * @param {string} tldString
 */
export const isTLD = (tldString) => {
  return (
    typeof window !== "undefined" &&
    (window.location.hostname.split(".").slice(-1)[0] === tldString
      ? true
      : false)
  );
};
export const getDynamicArticleByCategory = (
  page,
  category,
  postPerPage,
  locale
) => {
  page = page - 1 < 0 ? 0 : page - 1;
  var x;
  if (locale === "global") {
    x = `%22en%22`;
  } else {
    x = `%22${locale}%22`;
  }

  return `/graphql?query=query {
       newsList: articles( 
          locale: %22en%22,
          pagination: { start: ${postPerPage * page}, limit:  ${postPerPage} }, 
          sort: "articlePublishedAt:desc", 
          filters: {  published: { eq: true } , category: { startsWith: %22${category}%22  }} ) {
            data {
              id
              attributes{
                title
                status
                featuredImage{
                  data{
                    attributes{
                      url
                    }
                  }
                }
                slug
                title
            
             category
             createdAt
             slug
             articleOrigin
             articlePublishDate
             articlePublishedAt
             localizations(pagination: {  limit: -1 }) {
              data {
                attributes {
                  category
                  title
                  locale
                  body
                  featuredImage{
                    data{
                      attributes{
                        url
                      }
                    } 
                  }
                }
              }
            }
              }
            }
            meta {
              pagination {
                page
                pageSize
                pageCount
                total
              }
            }
          }
        }`;
};

export const listBasedOnStatus = (list) => {
  let article = list;

  if (process.env.GATSBY_ACTIVE_ENV === "production") {
    article = list.filter((item) => {
      return item.attributes.status !== "draft";
    });
  }
  return article;
};

export function getDataByLocaleArticles(data, locale) {
  return data.map((item) => {
    const { attributes } = item;
    const defaultAttributes = {
      title: attributes.title,
      summary: attributes.summary,
      slug: attributes.slug,
      body: attributes.body,
      image: attributes.featuredImage?.data?.attributes?.url,
      youtubeUrl: attributes.youtubeUrl,
    };
    const localization = attributes.localizations?.data.find(
      (l) => l.attributes.locale === locale
    );
    const localizedAttributes = localization?.attributes || {};

    return {
      id: item.id,
      attributes: {
        ...attributes,
        title:
          localizedAttributes.title?.trim().length > 0
            ? localizedAttributes.title
            : defaultAttributes.title,
        body:
          localizedAttributes.body?.trim().length > 0
            ? localizedAttributes.body
            : defaultAttributes.body,
        youtubeUrl:
          localizedAttributes.youtubeUrl?.trim().length > 0
            ? localizedAttributes.youtubeUrl
            : defaultAttributes.youtubeUrl,
        image:
          localizedAttributes.featuredImage?.data?.attributes?.url ||
          defaultAttributes.image,
      },
    };
  });
}

export function getLocaleDataForSingleArticle(data, locale) {
  let attributes = data.attributes;

  if (locale !== "en") {
    const localizations = attributes?.localizations?.data;
    const localization = localizations?.find(
      (l) => l.attributes.locale === locale
    );

    if (localization) {
      const localizedAttributes = localization.attributes;

      attributes = {
        ...attributes,
        title: localizedAttributes.title?.trim() || attributes.title,
        body: localizedAttributes.body?.trim() || attributes.body,
        youtubeUrl:
          localizedAttributes.youtubeUrl?.trim() || attributes.youtubeUrl,
        image:
          localizedAttributes.featuredImage?.data?.attributes?.url ||
          attributes.featuredImage?.data?.attributes?.url,
        ...(attributes.IndustryInsightsEBook && {
          IndustryInsightsEBook: localizedAttributes.IndustryInsightsEBook,
        }),
        ...(attributes.industryInsightsDownloadButtonLabel && {
          industryInsightsDownloadButtonLabel:
            localizedAttributes.industryInsightsDownloadButtonLabel,
        }),
        ...(attributes.formTitle && {
          formTitle: localizedAttributes.formTitle,
        }),
      };
    }
  }

  return { id: data.id, attributes };
}
